const TermAllPeriodList = `query termAllPeriodList($termUuid: String!){
  termAllPeriodList(termUuid: $termUuid){
    periodId
    name
    desc
    noOfWeeks
    inSprint
    sequence
    startDate
    endDate
    dateRange
    events{
      eventId
      name
      attendanceRequired
      scheduledDate
      actualDate
      eventTypeId{
        eventTypeId
        name
      }
      eventType
      formatDate
    }
  }
}`;

const AddTermPeriod = `mutation addTermPeriod(
  $termUuid: String!,
  $name: String!,
  $noOfWeeks: Int!,
  $inSprint: Boolean!,
  $startDate: Date!,
  $endDate: Date!,
  $desc: String
  ){
  addTermPeriod(
    termUuid: $termUuid,
    name: $name,
    noOfWeeks: $noOfWeeks,
    inSprint: $inSprint,
    startDate: $startDate,
    endDate: $endDate,
    desc: $desc
  ){
    termPeriod{
      periodId
      name
      desc
      noOfWeeks
      inSprint
      sequence
      termId{
        termId
        termUuid
      }
    }
  }
}`;

const UpdateTermPeriod = `mutation updateTermPeriod(
  $periodId:Int!,
  $name: String!,
  $desc: String
  ){
  updateTermPeriod(
    periodId: $periodId,
    name: $name,
    desc: $desc
  ){
    termPeriod{
      periodId
      name
      desc
      noOfWeeks
      inSprint
      sequence
      termId{
        termId
      }
    }
  }
}`;

const DeleteTermPeriod = `mutation deleteTermPeriod(
  $periodId:Int!
  ){
  deleteTermPeriod(
    periodId: $periodId,
  ){
    response
  }
}`;

const TermAllInSprintPeriodList = `
query termAllInSprintPeriodList($termUuid: String!){
  termAllInSprintPeriodList(termUuid: $termUuid){
    periodId
    name
    desc
    noOfWeeks
    inSprint
    sequence
    startDate
    endDate
    dateRange
    events{
      eventId
      name
      attendanceRequired
      scheduledDate
      actualDate
      eventTypeId{
        eventTypeId
        name
      }
      eventType
      formatDate
    }
  }
}`;

module.exports = {
  TERM_ALL_PERIODS_QUERY: TermAllPeriodList,
  TERM_ADD_PERIOD_MUTATION: AddTermPeriod,
  TERM_UPDATE_PERIOD_MUTATION: UpdateTermPeriod,
  TERM_DELETE_PERIOD_MUTATION: DeleteTermPeriod,
  TERM_ALL_IN_SPRINT_PERIODS_QUERY: TermAllInSprintPeriodList,
};
